export default {
  meta: {
    title: '提报意向',
    url: '/sitemap', // 埋点字段，上报归属的模块
    urlName: '选址地图' // 埋点字段，上报归属的模块
  }
};
